
<div class="modal-body-detail-row d-flex">
    <app-label-text class="mb-0" :title="title"></app-label-text>
    <app-normal-text :text="text"></app-normal-text>
</div>
